import api from './api'

/**
 * Map Session Service
 * Handles saving, loading, and sharing map comparison sessions
 */
const mapSessionService = {
  /**
   * Get all saved sessions for current user
   */
  async getSessions(params = {}) {
    const response = await api.get('/map-sessions', { params })
    return response.data
  },

  /**
   * Create a new map session
   */
  async createSession(data) {
    const response = await api.post('/map-sessions', data)
    return response.data
  },

  /**
   * Get a specific session by ID
   */
  async getSession(sessionId) {
    const response = await api.get(`/map-sessions/${sessionId}`)
    return response.data
  },

  /**
   * Update a session
   */
  async updateSession(sessionId, data) {
    const response = await api.put(`/map-sessions/${sessionId}`, data)
    return response.data
  },

  /**
   * Delete a session
   */
  async deleteSession(sessionId) {
    const response = await api.delete(`/map-sessions/${sessionId}`)
    return response.data
  },

  /**
   * Get a session by share code (public access)
   */
  async getSessionByCode(sessionCode) {
    const response = await api.get(`/map-sessions/share/${sessionCode}`)
    return response.data
  },
}

export default mapSessionService
